import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wholePage" }
const _hoisted_2 = { class: "listBox" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = { class: "search-bar" }
const _hoisted_6 = { class: "countries" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "nameColoum" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "native" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "nameColoum" }
const _hoisted_14 = { class: "name-bold" }
const _hoisted_15 = { class: "native-bold" }
const _hoisted_16 = { class: "name-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "overLay",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnToParent(_ctx.currentCode)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "x-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnToParent(_ctx.currentCode)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg" }, null, -1)
        ]))]),
        _cache[4] || (_cache[4] = _createElementVNode("b", null, "Country code", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            style: {"padding":"0 !important"},
            class: "search-bar",
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
            placeholder: "Search country codes"
          }, null, 512), [
            [_vModelText, _ctx.search]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            width: "20",
            height: "20",
            src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/magnifier.svg"
          }, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountryCodes(), (country, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"width":"100%"},
            key: index
          }, [
            (_ctx.currentCode !== '+' + country.CallingCode)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "country-row",
                  onClick: ($event: any) => (_ctx.returnToParent(country.CallingCode))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(country.country), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(country.nativeCountry), 1)
                  ]),
                  _createElementVNode("p", _hoisted_11, "+" + _toDisplayString(country.CallingCode), 1)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.currentCode == '+' + country.CallingCode)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "country-row",
                  onClick: ($event: any) => (_ctx.returnToParent(country.CallingCode))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(country.country), 1),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(country.nativeCountry), 1)
                  ]),
                  _createElementVNode("p", _hoisted_16, "+" + _toDisplayString(country.CallingCode), 1)
                ], 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}